import { useState } from 'react'
import toast from 'react-hot-toast'
import { addMassiveEmployees } from 'services/add-massive-employees'
import { Root as Profile } from 'services/get-profile'
import Button from 'shared/Button/Button'

import { Dropzone } from './components/Dropzone'

interface PropsModal {
  setModalOpen: (value: boolean) => void
  title: string
  profile: Profile | null
  isButtonClose?: boolean
}

export function ModalUploadFile({
  setModalOpen,
  title,
  isButtonClose = true,
  profile,
}: PropsModal) {
  const [uploadedFiles, setUploadedFiles] = useState<Blob | string>('')

  const handleSaveClick = async () => {
    try {
      if (!profile?.company?.id) {
        throw new Error('Id inválido')
      }

      const formData = new FormData()
      formData.set('file', uploadedFiles)

      const response = await addMassiveEmployees(formData, profile?.company?.id)

      if (response === 201) {
        setModalOpen(false)
        toast.success('Colaboradores cadastrados com sucesso')
        window.location.reload()
        return
      }

      toast.error('Erro ao tentar cadastrar colaboradores')
    } catch (error) {
      toast.error('Erro no servidor')
    }
  }

  return (
    <div className="min-h-screen w-full fixed left-0 top-0 flex justify-center items-center bg-black bg-opacity-70 z-50 transition-all duration-500 ease-in-out">
      <div className="w-[570px] h-[490px] flex flex-col items-center bg-white p-8 rounded-2xl shadow-2xl relative">
        {isButtonClose && (
          <button
            className="absolute top-1 right-3 text-3xl cursor-pointer"
            onClick={() => setModalOpen(false)}
          >
            &times;
          </button>
        )}
        <header>
          <h1 className="text-2xl font-bold text-center dark:text-black">
            {title}
          </h1>
        </header>
        <main className="w-full">
          <div className="w-[300px] flex justify-center mx-auto items-center mb-14"></div>
          <section className="w-full">
            <Dropzone setUploadedFiles={setUploadedFiles} />
          </section>
          <section className="w-full mt-5 mx-auto flex justify-between gap-4 items-center">
            <a
              href={
                'https://virotrip-public.s3.amazonaws.com/cache/modeloImporta%C3%A7%C3%A3oEmMassa.xlsx'
              }
              className="text-[#4F46E5] font-medium underline"
            >
              Download do Modelo
            </a>
            <div>
              <Button
                type="button"
                onClick={() => setModalOpen(false)}
                className="px-9 py-17 rounded-full border border-solid border-gray-300 text-xs text-[#374151] mr-4"
              >
                Cancelar
              </Button>
              <Button
                type="button"
                onClick={handleSaveClick}
                className="px-9 py-17 rounded-full bg-[#4F46E5] text-white"
              >
                Salvar
              </Button>
            </div>
          </section>
        </main>
      </div>
    </div>
  )
}
